<template>
  <UiInput
    ref="inputRef"
    v-model="formattedValue"
    type="text"
    hide-details
    @change="$emit('update:modelValue', formattedValue)"
  />
</template>

<script setup lang="ts">
import { CurrencyDisplay, useCurrencyInput } from "vue-currency-input";

const props = defineProps<{
  modelValue: number | string;
  min: number | string;
  max: number | string;
}>();

defineEmits(["update:modelValue", "change"]);

const { inputRef, setValue, formattedValue } = useCurrencyInput(
  {
    currency: "USD",
    locale: "en",
    currencyDisplay: CurrencyDisplay.show,
    precision: 2,
    useGrouping: false,
    hideGroupingSeparatorOnFocus: false,
    hideNegligibleDecimalDigitsOnFocus: false,
    valueRange: {
      min: Number(props.min),
      max: Number(props.max),
    },
  },
  false,
);

watch(
  () => props.modelValue,
  (value: number | string) => {
    setValue(Number(value));
  },
);
</script>
